// export what you need
export { default as SmileOutline } from "@ant-design/icons/lib/outline/SmileOutline";
export { default as MehOutline } from "@ant-design/icons/lib/outline/MehOutline";

// export what antd other components need
export { default as CloseOutline } from "@ant-design/icons/lib/outline/CloseOutline";
export { default as CheckOutline } from "@ant-design/icons/lib/outline/CheckOutline";
export { default as LoadingOutline } from "@ant-design/icons/lib/outline/LoadingOutline";
export { default as CheckCircleOutline } from "@ant-design/icons/lib/outline/CheckCircleOutline";
export { default as InfoCircleOutline } from "@ant-design/icons/lib/outline/InfoCircleOutline";
export { default as CloseCircleOutline } from "@ant-design/icons/lib/outline/CloseCircleOutline";
export { default as ExclamationCircleOutline } from "@ant-design/icons/lib/outline/ExclamationCircleOutline";
export { default as CheckCircleFill } from "@ant-design/icons/lib/fill/CheckCircleFill";
export { default as InfoCircleFill } from "@ant-design/icons/lib/fill/InfoCircleFill";
export { default as CloseCircleFill } from "@ant-design/icons/lib/fill/CloseCircleFill";
export { default as ExclamationCircleFill } from "@ant-design/icons/lib/fill/ExclamationCircleFill";
export { default as UpOutline } from "@ant-design/icons/lib/outline/UpOutline";
export { default as DownOutline } from "@ant-design/icons/lib/outline/DownOutline";
export { default as LeftOutline } from "@ant-design/icons/lib/outline/LeftOutline";
export { default as RightOutline } from "@ant-design/icons/lib/outline/RightOutline";
export { default as RedoOutline } from "@ant-design/icons/lib/outline/RedoOutline";
export { default as CalendarOutline } from "@ant-design/icons/lib/outline/CalendarOutline";
export { default as SearchOutline } from "@ant-design/icons/lib/outline/SearchOutline";
export { default as BarsOutline } from "@ant-design/icons/lib/outline/BarsOutline";
export { default as StarFill } from "@ant-design/icons/lib/fill/StarFill";
export { default as FilterOutline } from "@ant-design/icons/lib/outline/FilterOutline";
export { default as CaretUpOutline } from "@ant-design/icons/lib/outline/CaretUpOutline";
export { default as CaretDownOutline } from "@ant-design/icons/lib/outline/CaretDownOutline";
export { default as PlusOutline } from "@ant-design/icons/lib/outline/PlusOutline";
export { default as FileOutline } from "@ant-design/icons/lib/outline/FileOutline";
export { default as FolderOpenOutline } from "@ant-design/icons/lib/outline/FolderOpenOutline";
export { default as FolderOutline } from "@ant-design/icons/lib/outline/FolderOutline";
export { default as PaperClipOutline } from "@ant-design/icons/lib/outline/PaperClipOutline";
export { default as PictureOutline } from "@ant-design/icons/lib/outline/PictureOutline";
export { default as EyeOutline } from "@ant-design/icons/lib/outline/EyeOutline";
export { default as DeleteOutline } from "@ant-design/icons/lib/outline/DeleteOutline";
